import { Quote, Linkedin } from "lucide-react";

/*
 * Testimonials are transcribed verbatim from LinkedIn recommendation
 * screenshots shared by the client (Babur).
 */
const testimonials = [
    {
        quote:
            "I wanted to share some thoughts about Babur, who I had the pleasure of working with for almost a year. Babur is not just talented, he's incredibly smart and dedicated. But what really impressed me was how quickly he learns new things! If you're in need of top-notch photography, videography, or social media growth expertise, Babur is your go-to guy. Highly recommend him without hesitation!",
        name: "Camilla Kossaifi",
        role: "Marketing Director",
        company: "Forests Hills Dubai",
    },
    {
        quote:
            "I am excited to recommend Babur, an incredibly talented videographer and photographer! I've had the pleasure of working with him on several projects, and I can confidently say that his professionalism and creativity set him apart in the industry. From the very beginning, Babur impressed me with his attention to detail and unique vision. Each shoot he takes on is approached with enthusiasm and a fresh perspective, resulting in stunning visuals that truly capture the essence of the moment. He not only understands the technical aspects of his craft but also has an innate ability to connect with clients and make them feel comfortable in front of the camera. If you're looking for someone who can bring your creative ideas to life, I highly recommend reaching out to Babur! His work speaks volumes, and I'm positive you won't be disappointed. Feel free to connect with him or check out his portfolio — you'll be amazed!",
        name: "Francis El Khazen",
        role: "Sales Manager",
        company: "RTI Real Estate",
    },
    {
        quote:
            "Babur does absolutely impressive work, I'm pleased to be working with him. And a huge plus is that his patience and creative eye is on another level. Keep up your excellent work and work ethics!",
        name: "Natalie Soyege",
        role: "HR & PR",
        company: "RTI Real Estate",
    },
    {
        quote:
            "It's been an absolute pleasure to work with Babur. From the day I joined, he has been selflessly helpful not just helping me get comfortable, but also with the leads and support he and his team have been providing. I highly recommend him with this leadership skills and knowledge about Real estate Digital Marketing. Never came across with someone with so much talent and passion. May you get all what you deserved.",
        name: "Eslam Khalifa",
        role: "Property Consultant",
        company: "RTI Real Estate",
    },
];

export default function Testimonials() {
    return (
        <section id="testimonials" className="relative py-24 sm:py-32 border-t border-white/10 bg-[#0d0d0f]">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-14">
                    <div className="md:col-span-8">
                        <div className="eyebrow mb-4 flex items-center gap-3">
                            <span className="inline-block w-10 h-[2px] bg-brand" /> LinkedIn recommendations
                        </div>
                        <h2 className="font-display font-medium tracking-[-0.04em] text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.02]">
                            Written by the people<br />
                            <span className="text-brand">who worked with us.</span>
                        </h2>
                    </div>
                    <div className="md:col-span-4 md:text-right">
                        <a
                            href="https://www.linkedin.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 text-sm font-mono uppercase tracking-widest text-white/60 hover:text-brand transition-colors border-b border-white/20 hover:border-brand pb-1"
                        >
                            <Linkedin className="w-4 h-4" /> View on LinkedIn &rarr;
                        </a>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6">
                    {testimonials.map((t, i) => (
                        <div
                            key={i}
                            data-testid={`testimonial-card-${i}`}
                            className="relative bg-[#141414] border border-white/10 p-8 sm:p-10 group hover:border-brand/50 transition-colors flex flex-col"
                        >
                            <div className="flex items-start justify-between mb-6">
                                <Quote className="w-8 h-8 text-brand" />
                                <span className="inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest text-white/40">
                                    <Linkedin className="w-3 h-3" /> LinkedIn / Recommendations
                                </span>
                            </div>
                            <p className="text-white/85 leading-relaxed text-[15px] flex-1">
                                {t.quote}
                            </p>
                            <div className="mt-8 pt-6 border-t border-white/10">
                                <div className="font-display font-semibold text-white text-lg tracking-[-0.02em]">{t.name}</div>
                                <div className="text-xs font-mono uppercase tracking-widest text-white/50 mt-1.5">
                                    {t.role} &middot; <span className="text-brand">{t.company}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
